import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LibraryViewIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.6 11.41C22.96 10.21 19.38 4.21001 12 4.21001C4.62 4.21001 1.04 10.2 0.4 11.41C0.2 11.78 0.2 12.23 0.4 12.6C1.04 13.8 4.62 19.8 12 19.8C19.38 19.8 22.96 13.81 23.6 12.6C23.8 12.23 23.8 11.79 23.6 11.42V11.41ZM12 18.29C5.69 18.29 2.5 13.29 1.78 12C2.5 10.71 5.69 5.71001 12 5.71001C18.31 5.71001 21.5 10.71 22.22 12C21.5 13.29 18.31 18.29 12 18.29Z"
        fill={color}
      />
      <path
        d="M12 7.25C9.38 7.25 7.25 9.38 7.25 12C7.25 14.62 9.38 16.75 12 16.75C14.62 16.75 16.75 14.62 16.75 12C16.75 9.38 14.62 7.25 12 7.25ZM12 15.25C10.21 15.25 8.75 13.79 8.75 12C8.75 10.21 10.21 8.75 12 8.75C13.79 8.75 15.25 10.21 15.25 12C15.25 13.79 13.79 15.25 12 15.25Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LibraryViewIcon.displayName = 'LibraryViewIcon';
